import { render } from "./dashboardindex.vue?vue&type=template&id=0aca864e"
import script from "./dashboardindex.vue?vue&type=script&lang=js"
export * from "./dashboardindex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__